import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { OpeningHoursLayout } from "./OpeningHours.layout";
export const OpeningHoursWidget = (props)=>{
    return /*#__PURE__*/ _jsx(OpeningHoursLayout, {
        items: props.items
    });
};
